<script>
export default {
  props: {
    location: {
      type: Object
    },
    printRadius: {
      type: Number || String
    },
    digitalRadius: {
      type: Number || String
    },
    zoomControl: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      options: {
        mapTypeId: "terrain",
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false
      },
      centerOptions: {
        fillColor: "#1591EF",
        fillOpacity: 1,
        strokeOpacity: 0
      },
      printOptions: {
        strokeColor: "#CF30F7",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillOpacity: 0
      },
      digitalOptions: {
        strokeColor: "#1591EF",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillOpacity: 0
      }
    }
  }
}
</script>

<template>
  <div class="h-100 pb-3">
    <gmap-map :center="this.location.lat && this.location.lng ? this.location : { lat: -25.023, lng: 134.449 }" :options="options" :zoom="this.location.lat && this.location.lng ? 11 : 3" :zoom-control="zoomControl" class="h-100">
      <gmap-circle v-if="this.location.lat && this.location.lng" :center="this.location.lat && this.location.lng ? this.location : { lat: -25.023, lng: 134.449 }" :radius="600" :options="centerOptions"></gmap-circle>
      <gmap-circle v-if="this.printRadius && this.location.lat && this.location.lng" :radius="this.printRadius" :center="this.location" :options="printOptions"></gmap-circle>
      <gmap-circle v-if="this.digitalRadius && this.location.lat && this.location.lng" :radius="this.digitalRadius" :center="this.location" :options="digitalOptions"></gmap-circle>
    </gmap-map>
    <div class="d-flex justify-content-end mt-2 mr-2">
      <div class="d-flex">
        <div class="mr-3 d-flex align-items-center" v-if="digitalRadius">
          <div class="key key--digital mr-1"></div>
          <p class="mb-0">Digital</p>
        </div>
        <div class="d-flex align-items-center" v-if="printRadius">
          <div class="key key--print mr-1"></div>
          <p class="mb-0">Print</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .key {
    width: 10px;
    height: 10px;
    border: 1px solid #1591EF;
    border-radius: 100%;
    display: block;
  }

  .key--print {
    border: 1px solid #CF30F7;
  }

  .key--digital {
    border: 1px solid #1591EF;
  }
</style>